import Meetings from './Meetings'
import Milestones from './Milestones'
import Tasks from './Tasks'
import ProfileFields from './ProfileFields'
import PeoplePill from './PeoplePill'
import PeopleFields from './PeopleFields'
import CurrentClientAvatar from './CurrentClientAvatar'
import EditCurrentClientInfo from './EditCurrentClientInfo'
import CurrentClientName from './CurrentClientName'
import CurrentClientWealthMission from './CurrentClientWealthMission'
import ConversationButton from './ConversationButton'
import ClientAccountInfo from './ClientAccountInfo'

const abundanceEngineExports = {
  Client_Meetings: Meetings,
  Client_Milestones: Milestones,
  Client_Tasks: Tasks,
  Client_ProfileFields: ProfileFields,
  Client_PeoplePill: PeoplePill,
  Client_PeopleFields: PeopleFields,
  CurrentClientAccountInfo: ClientAccountInfo,
  ConversationButton,
  CurrentClientAvatar,
  CurrentClientName,
  CurrentClientWealthMission,
  EditCurrentClientInfo
}

export default abundanceEngineExports
